import {
  buildUserStatusByBranchId,
  isBranchInactiveForUser,
  mergeUserStatusFromDetails,
  mergeUserStatusIntoBranches,
} from './branchAccess'
import {
  getBranchPermissionIndex,
  getBranchPermissionRecord,
  getPermissionModuleSlug,
  hasAnyPermission,
  hasPermission,
} from './branchPermissions'
import {
  GLOBAL_SETTINGS_CACHE_STORAGE_KEY,
  ACCESS_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  USER_DETAILS_STORAGE_KEY,
  SELECTED_BRANCH_STORAGE_KEY,
  SELECTED_BRANCH_META_STORAGE_KEY,
  BRANCH_PERMISSIONS_STORAGE_KEY,
} from './constants'
import {
  formatLongDate,
  formatDateOnly,
  formatDateTime,
  formatTimeOnly,
  formatDateTimeParts,
  formatInTimezone,
  getRelativeTime,
  getStoredTimezone,
  diffFromNow,
  inTimezone,
  isPast,
  isValidDate,
  toUtcISO,
  useTimezone,
} from './datetime'
import { globalSettingsStorage } from './globalSettingsStorage'
import { clearAllowedPlatform, clearLoginMeta } from './loginMeta'
import { permissionStorage } from './permissionStorage'
import { isProfileComplete } from './profile'
import { remoteLogin } from './remoteLogin'
import { tokenStorage } from './tokenStorage'
import { userStorage } from './userStorage'

export {
  ACCESS_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  USER_DETAILS_STORAGE_KEY,
  SELECTED_BRANCH_STORAGE_KEY,
  SELECTED_BRANCH_META_STORAGE_KEY,
  GLOBAL_SETTINGS_CACHE_STORAGE_KEY,
  BRANCH_PERMISSIONS_STORAGE_KEY,
  globalSettingsStorage,
  tokenStorage,
  userStorage,
  permissionStorage,
  remoteLogin,
  isProfileComplete,
  buildUserStatusByBranchId,
  isBranchInactiveForUser,
  mergeUserStatusFromDetails,
  mergeUserStatusIntoBranches,
  formatDateOnly,
  formatDateTime,
  formatTimeOnly,
  formatLongDate,
  formatDateTimeParts,
  formatInTimezone,
  getRelativeTime,
  getStoredTimezone,
  diffFromNow,
  inTimezone,
  isPast,
  isValidDate,
  toUtcISO,
  useTimezone,
  // Branch-scoped permission helpers — the app-wide permission check.
  hasPermission,
  hasAnyPermission,
  getBranchPermissionRecord,
  getBranchPermissionIndex,
  getPermissionModuleSlug,
}

// One-line helpers — anywhere in the app can do:
//   import { getAccessToken, getUserDetails, getSelectedBranch, setSelectedBranch } from '../utils';
export const getAccessToken = () => tokenStorage.getAccessToken()
export const setAccessToken = (token) => tokenStorage.setAccessToken(token)
export const getUserDetails = () => userStorage.getUserDetails()
export const getSelectedBranch = () => userStorage.getSelectedBranch()
export const setSelectedBranch = (branch) => userStorage.setSelectedBranch(branch)
export const getSelectedBranchMeta = () => userStorage.getSelectedBranchMeta()
export const clearAllData = () => {
  tokenStorage.clearTokens()
  userStorage.clearAllUserData()
  globalSettingsStorage.clearCached()
  // Cached branch permissions belong to the session ending here.
  permissionStorage.clearPermissions()
  clearLoginMeta()
  clearAllowedPlatform()
}

export function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

// Kept for backwards compatibility — renders "DD/MM/YYYY" in the admin's
// timezone. New code should import `formatLongDate` from './datetime'.
export function formatDate(date) {
  return formatLongDate(date)
}

export function debounce(func, wait) {
  let timeoutId = null
  return (...args) => {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }
    timeoutId = setTimeout(() => func(...args), wait)
  }
}
